import { render, staticRenderFns } from "./AnnotationImportModal.vue?vue&type=template&id=928af232&scoped=true&"
import script from "./AnnotationImportModal.vue?vue&type=script&lang=js&"
export * from "./AnnotationImportModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationImportModal.vue?vue&type=style&index=0&id=928af232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928af232",
  null
  
)

export default component.exports